import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseSurveysFormValues } from "pages/CourseCreate/Surveys/CourseSurveysForm";

const save = (courseId: number, data: CourseSurveysFormValues): AxiosPromise => {
  return api.post(endpoints.COURSE_SURVEYS.SAVE(courseId), data);
};

export const courseSurveysApi = {
  save,
};
